const rules = [
    {
        field: 'franchiseIds',
        method: 'isEmpty',
        validWhen: false,
        message: 'Instance is required.'
    }
];

export default rules;
